export const MODIFIER_ACTIVE = '-active';
export const MODIFIER_OVERFLOW = '-overflow';
export const MODIFIER_HAS_OVERFLOW = '-has-overflow';
export const CLASS_ITEM = '.owpi-spa-usp-modules__item';
